export default {
  REPLY: "reply",
  FORWARD: "forward",
};
